import { formatDimensionDisplay } from "@utils/DimensionConversion";
import { isNil } from "lodash-es";

/**
 * Get the formatted dimensions for the order item.
 *
 * @param orderItem
 * @returns
 */
export const getFormattedDimensions = (orderItem: IOrder_Item): { widthDetail: string; heightDetail: string; depthDetail: string } => {
    const dimensionUnit = orderItem.Catalog_Item?.Dimension_Unit;
    const abbreviation = dimensionUnit?.abbreviation;

    const isCustomWidthDim = !isNil(orderItem.width) && orderItem.width !== 0;
    const widthDimension = isCustomWidthDim ? orderItem.width : orderItem.Catalog_Item!.width;

    const isCustomHeightDim = !isNil(orderItem.height) && orderItem.height !== 0;
    const heightDimension = isCustomHeightDim ? orderItem.height : orderItem.Catalog_Item!.height;

    const isCustomDepthDim = !isNil(orderItem.depth) && orderItem.depth !== 0;
    const depthDimension = isCustomDepthDim ? orderItem.depth : orderItem.Catalog_Item!.depth;

    const width = widthDimension || 0;
    const height = heightDimension || 0;
    const depth = depthDimension || 0;

    // Get the dimension unit ID from the catalog item
    const dimensionUnitId = orderItem.Catalog_Item?.dimension_unit_id;

    // Format the dimension value based on the unit
    const formattedWidthDimension = formatDimensionDisplay(width, dimensionUnitId);
    const formattedHeightDimension = formatDimensionDisplay(height, dimensionUnitId);
    const formattedDepthDimension = formatDimensionDisplay(depth, dimensionUnitId);

    // If we have a formatted dimension, use it; otherwise fall back to old format
    const widthDetail = formattedWidthDimension || (abbreviation ? `${widthDimension}${abbreviation}` : `${widthDimension}`);
    const heightDetail = formattedHeightDimension || (abbreviation ? `${heightDimension}${abbreviation}` : `${heightDimension}`);
    const depthDetail = formattedDepthDimension || (abbreviation ? `${depthDimension}${abbreviation}` : `${depthDimension}`);

    return { widthDetail, heightDetail, depthDetail };
};
